<template>
  <div class="wrapper">
    <Header :callbackCount="callbackCount" />

    <div class="content">
      <router-view />

    </div>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import Header from "@/components/shared/Header.vue";
import Footer from "@/components/shared/Footer.vue";
import CompanyService from "@/services/Company.service";

export default {
  name: "Home",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      callbackCount: null
    }
  },
  methods: {
    loadCallbackCount() {
      CompanyService.getCallbackCount().then(result => { this.callbackCount = result.data})
    }
  }
};
</script>

<style scoped>
.wrapper {
  height: 100%;
}

.content {
  min-height: 100%;
  padding-top: 72px;
  padding-bottom: 70px;
  margin-top: -72px;
  margin-bottom: -60px;
}
</style>
